import { useEffect } from 'react';
import { useTheme } from "@/components/providers/ThemeProvider";

/**
 * Hook that syncs the browser's theme-color meta tag with the current theme.
 * This affects the browser UI color on mobile devices and some desktop browsers.
 */
export function useThemeColor() {
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    // Get the theme-color meta tag
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    
    if (metaThemeColor) {
      // Light mode: white, Dark mode: matches --background dark value
      const color = resolvedTheme === 'dark' ? '#1a1f2e' : '#ffffff';
      metaThemeColor.setAttribute('content', color);
    }
  }, [resolvedTheme]);
}
